/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useIntl } from 'react-intl';
import ContextSubMenu from 'Common/Components/ContextMenu/components/ContextSubMenu';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBulkUpdateField, setBulkUpdateValue, showContextMenu,
  updateVulnFromAsset
} from 'store/Contextualization/AssetDetail/actions';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { MODAL_MANAGE_BULK_UPDATE_CONFIRMATION } from 'store/modals/modals';
import { openModal } from 'store/modals/actions';
import { SeverityIcon, SeverityLetter } from './styled';

const SeverityItem = ({ title }) => {
  const dispatch = useDispatch();
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const oneVulnSelected = vulnsSelected.length === 1;
  const isBulk = vulnsSelected.length > 1;
  const selectedVuln = vulnsSelected[0];
  const capitalizedSeverity = title.charAt(0).toUpperCase() + title.slice(1);
  const letter = capitalizedSeverity.charAt(0);

  const applySeverity = () => {
    if (isBulk) {
      dispatch(setBulkUpdateField('severity'));
      dispatch(setBulkUpdateValue(title));
      dispatch(openModal(MODAL_MANAGE_BULK_UPDATE_CONFIRMATION));
    } else dispatch(updateVulnFromAsset(selectedVuln, 'severity', title));
    dispatch(showContextMenu(false));
  };

  return (
    <MenuItem
      isSelected={ oneVulnSelected && selectedVuln.severity === title }
      title={ capitalizedSeverity }
      icon={ (
        <SeverityLetter title={ capitalizedSeverity } type={ letter }>
          { letter }
        </SeverityLetter>
      ) }
      onClick={ applySeverity }
    />
  );
};

export const Severity = () => {
  const intl = useIntl();

  return (
    <ContextSubMenu
      title={ intl.formatMessage({ id: 'manage.cm.severity' }) }
      icon={ <SeverityIcon /> }
    >
      <SeverityItem title="critical" />
      <SeverityItem title="high" />
      <SeverityItem title="medium" />
      <SeverityItem title="low" />
      <SeverityItem title="informational" />
      <SeverityItem title="unclassified" />
    </ContextSubMenu>
  );
};
